import React from "react";
import { EmptyReport } from "./ReportCards";
import { dt, money, n, td, th } from "./reportFormat";

function label(col) {
  return String(col || "").replaceAll("_", " ");
}

function val(row, col) {
  const v = row?.[col];
  const key = String(col || "").toLowerCase();
  if (key.includes("percent") || key.includes("margin")) return `${n(v)}%`;
  if (
    key.includes("amount") ||
    key.includes("spent") ||
    key.includes("income") ||
    key.includes("earning") ||
    key.includes("balance") ||
    key.includes("withdrawn") ||
    key.includes("revenue") ||
    key.includes("profit") ||
    key.includes("price") ||
    key.includes("cost") ||
    key.includes("charge") ||
    key.includes("fee") ||
    key.includes("tax") ||
    key.includes("discount") ||
    key === "subtotal" ||
    key === "grand_total"
  ) return money(v);
  if (key.includes("_at") || key.includes("login") || key.includes("expiry")) return dt(v);
  if (typeof v === "boolean") return v ? "Yes" : "No";
  if (typeof v === "number") return n(v);
  return String(v ?? "-");
}

export default function DataTable({ rows = [], columns = [], maxHeight = "max-h-[520px]", onRowClick = null }) {
  if (!rows.length) return <EmptyReport />;

  return (
    <div className={`overflow-auto rounded-[14px] border border-[#f7d8dc] ${maxHeight}`}>
      <table className="min-w-full border-collapse bg-white">
        <thead className="sticky top-0 z-10 bg-[#f5cfd5]">
          <tr>{columns.map((c) => <th className={th} key={c}>{label(c)}</th>)}</tr>
        </thead>
        <tbody className="divide-y divide-slate-100">
          {rows.map((r, idx) => (
            <tr key={idx} onClick={onRowClick ? () => onRowClick(r) : undefined} className={`transition hover:bg-[#fff8f9] ${onRowClick ? "cursor-pointer" : ""}`}>
              {columns.map((c) => <td className={td} key={c}>{val(r, c)}</td>)}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
